import React, { useMemo } from 'react';
import {
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import AssessmentPicker from 'js/routes/Organizations/components/OrgComponent/AssessmentPicker';
import OrgSnapshotChrome, { orgPageTitle } from './OrgSnapshotChrome';
import OrgSnapshotSetTabs from './OrgSnapshotSetTabs';
import { teamIdFromOrgDetailSearch } from 'js/utils/org-detail-url';
import {
  buildSnapshotTrendsPickerPath,
  isSnapshotTrendsPath,
  snapshotSetPath,
} from './org-snapshot-utils';

export default function OrgSnapshotSetLayout({
  organization,
  workspace,
  assessmentHistorySummaries = [],
  chart = null,
  children = null,
}) {
  const { path } = useRouteMatch();
  const { workspaceId, orgId, sourceType, sourceKey } = useParams();
  const trendsMatch = useRouteMatch(`${path}/trends/:subOrgId?`);
  const subOrgId = trendsMatch?.params?.subOrgId;
  const history = useHistory();
  const location = useLocation();
  const decodedKey = useMemo(() => decodeURIComponent(sourceKey), [sourceKey]);
  const onTrends = isSnapshotTrendsPath(location.pathname);
  const pageTitle = orgPageTitle(organization, workspace);

  return (
    <OrgSnapshotChrome
      workspaceId={workspaceId}
      orgId={orgId}
      organization={organization}
      workspace={workspace}
      sourceKey={decodedKey}
      extra={{
        title: pageTitle,
        fallbackTitle: '\u00a0',
        header: organization ? (
          <AssessmentPicker
            assessmentHistorySummaries={assessmentHistorySummaries}
            defaultActiveKey={decodedKey}
            onChoose={(key) => {
              const summary = assessmentHistorySummaries.find(
                (row) => row.assessment_key === key
              );
              const nextType =
                summary?.assessment_type === 'rubric' ? 'rubric' : 'assessment';
              if (onTrends) {
                history.push(
                  buildSnapshotTrendsPickerPath({
                    workspaceId,
                    orgId,
                    sourceType: nextType,
                    sourceKey: key,
                    subOrgId,
                    teamId: teamIdFromOrgDetailSearch(location.search),
                  })
                );
                return;
              }
              history.push(snapshotSetPath(workspaceId, orgId, nextType, key));
            }}
          />
        ) : null,
        chart,
        tabs: (
          <OrgSnapshotSetTabs
            workspaceId={workspaceId}
            orgId={orgId}
            sourceType={sourceType}
            sourceKey={decodedKey}
            pathname={location.pathname}
            subOrgId={subOrgId}
          />
        ),
      }}
    >
      {children}
    </OrgSnapshotChrome>
  );
}
